import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import getRouteWindowTitle from './router/get-route-window-title';

export function initGtm(googleTGMContainer) {
  Vue.use(VueGtm, {
    id: googleTGMContainer
  });
}

// If this is still needed will depends on how data is received by gtm
/**
 *
 * @param {import('node_modules/vue-router/types/index').Route} to
 */
export function pageTrackerTemplate(to) {
  return {
    page_title: getRouteWindowTitle(to),
    page_path: `${process.env.VUE_APP_PUBLIC_PATH.substring(
      0,
      process.env.VUE_APP_PUBLIC_PATH.length - 1
    )}${to.path}`,
    page_location: window.location.href
  };
}
